import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button/Button';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function PatientCareContact() {
  return (
    <>
      <Typography variant="body1B" sx={{ mb: 1 }}>
        Atendimento à Oyana
      </Typography>

      <Typography sx={{ mb: 2 }}>Entre em contato com nossa equipe de atendimento em horário comercial.</Typography>

      <Button
        variant="inline"
        color="primary"
        href={process.env.REACT_APP_WHATSAPP}
        target="_blank"
        component="a"
        endIcon={<WhatsAppIcon />}
      >
        Falar com Equipe de Cuidados
      </Button>
    </>
  );
}
